export const addDaysToDateHelper = (date: string | Date, daysToAdd: number) => {
  if (!date || !String(daysToAdd)) {
    return null;
  }

  const formatedDate = new Date(date);

  formatedDate.setHours(0, 0, 0, 0);
  formatedDate.setDate(new Date(formatedDate).getDate() + daysToAdd);
  formatedDate.setHours(0, 0, 0, 0);

  return formatedDate;
};
